import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=3874856a&scoped=true&"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=3874856a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874856a",
  null
  
)

export default component.exports